import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import { excludeHiddenAnswers } from '../../machine/helpers/logic';
import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class DistributeScaleApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { answersActors: answersActorsRaw, id, responseActor } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;
        const answersActors = excludeHiddenAnswers(answersActorsRaw);
        return {
            question: id,
            data: answersActors.map((answerActor) => {
                const { id, response } = answerActor.getSnapshot().context;
                const { value } = response.getSnapshot().context;
                return {
                    answer: id,
                    int: typeof value === 'number' ? value : 0,
                    bool: true,
                };
            }),
            comment,
        };
    }

    public validate({
        answersActors: answersActorsRaw,
        params: { distributeScore, distributeSurplus, required },
    }: QuestionContext): boolean {
        if (required) {
            const answersActors = excludeHiddenAnswers(answersActorsRaw);
            const sum = answersActors.reduce(
                (acc, answerActor) =>
                    acc + (answerActor.getSnapshot().context.response.getSnapshot().context.value as number),
                0,
            );
            return (
                (distributeSurplus && sum === parseInt(distributeScore.toString())) || (!distributeSurplus && sum > 0)
            );
        }

        return true;
    }
}
